import { SocialAuthCallbackResponse } from '../../library/interfaces';
const { FLUZ_WEB_SERVER_URL } = process.env;
const authServiceOAuthUrl = `${FLUZ_WEB_SERVER_URL ? FLUZ_WEB_SERVER_URL : ''}/api/v1/auth/login`;
import { handleSocialAuthResponse } from '../../utils/oauth/handleSocialAuthResponse';

const receiveMessage = (
  event: MessageEvent,
  intervalId?: NodeJS.Timeout,
  callback?: (data: SocialAuthCallbackResponse, closed: boolean) => void
) => {
  // Validate callback url, that it comes from us.
  const { data } = event;
  const validCallbackUri =
    typeof data === 'string' && (data.indexOf('fluzapp') !== -1 || data.indexOf('callback/social-auth') !== -1);
  if (!validCallbackUri) {
    return;
  } else {
    // Removing event listener, otherwise we will keep receiving messages from the window.
    window.removeEventListener('message', receiveMessage);
    return handleSocialAuthResponse(data, intervalId, callback);
  }
};

export default function useSocialAuth() {
  const openOAuthSignInWindow = (
    socialAuthProvider: string,
    callback: (data: SocialAuthCallbackResponse, closed: boolean) => void
  ) => {
    const url = `${authServiceOAuthUrl}/${socialAuthProvider}`;
    const name = '<iframe>';
    const windowOptions = 'toolbar=no, menubar=no, width=600, height=700, top=100, left=100';
    const windowObjectReference: Window | null = window.open(url, name, windowOptions);
    // remove any existing event listeners if any
    window.removeEventListener('message', receiveMessage);
    if (windowObjectReference) {
      // Without this IF, typescript will not let us focus on the window.
      windowObjectReference.focus();
    }

    function checkIfWindowClosed() {
      const intervalId = setInterval(() => {
        if ((windowObjectReference as Window).closed) {
          callback({ success: false, token: undefined, statusCode: undefined, message: undefined }, true);
          window.removeEventListener('message', receiveMessage);
          clearInterval(intervalId);
        }
      }, 3000);
      return intervalId;
    }
    const intervalId = checkIfWindowClosed();

    // add the listener for receiving a message from the popup
    window.addEventListener('message', (event) => {
      return receiveMessage(event, intervalId, callback), false;
    });
  };

  return { openOAuthSignInWindow };
}
